import { LockCircleIcon } from "@/shared/icons";

type Props = {
  onClick: () => void;
};

export default function AccountCharLocked({ onClick }: Props) {
  return (
    <button
      type="button"
      className="text-lg w-fill grow flex flex-col justify-center items-center uppercase -m-[var(--card-padding)] p-[--card-padding]"
      onClick={onClick}
    >
      <LockCircleIcon size={48} className="mx-auto mb-5 transition group-hover:text-accent" />
      <div className="font-bold text-sm transition group-hover:text-accent mb-1">Платный слот</div>
      <div className="text-white/70 text-xxs transition group-hover:text-white">
        Разблокировать для персонажа
      </div>
    </button>
  );
}
